import React from 'react';
import './Preview.less';

export function EmptyPanel() {
  return <div className="dp-entitydetails-empty-panel">
      <span className="dp-entitydetails-empty-panel__text">No details available for this entity</span>
  </div>;
}
